export enum LookerDashboardTypeEnum {
    AiGov = 'AiGov',
    Compliance = 'Compliance',
    DSR = 'DSR',
    DsrAuditLog = 'DsrAuditLog',
    GOV = 'GOV',
    Risk = 'Risk',
    TPRM = 'TPRM',
    CMP = 'CMP',
    DsrCaliforniaDrop = 'DsrCaliforniaDrop'
}